<template>
<div id="JobForm">
    <v-breadcrumbs :items="breadcrumbs" class="pt-0 pl-0">
        <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
        </template>
        <template v-slot:item="props">
            <router-link :to="props.item.to" :class="[props.item.disabled && 'disabled']">{{ props.item.text }}
            </router-link>
        </template>
    </v-breadcrumbs>
    <v-dialog content-class="dialog-referenceNumber" max-width="450px" persistent v-model="dialogReferenceNumber">
        <v-card>
            <v-card-title>{{ title1 }}</v-card-title>
            <v-form data-vv-scope="formAddReferenceNumber" lazy-validation ref="formReferenceNumber">
                <v-card-text class="pt-0">
                    <v-container grid-list-md pb-0>
                        <v-layout wrap>
                            <v-flex md12 xs12>
                                <v-autocomplete :items="refNumberList" :loading="loadingSelectRef" label="Reference Number" multiple small-chips v-model="reference_number"></v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialogConfirm = true" style="width: 85px">Cancel</v-btn>
                        <v-btn @click="save" color="primary" style="width: 85px">Save</v-btn>
                    </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
        <v-dialog max-width="450px" persistent v-model="dialogConfirm">
            <v-card>
                <v-card-title>
                    <span class="headline">Alert</span>
                </v-card-title>
                <v-card-text>{{ title2 }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
                    <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    <div class="mb-4">
        <v-layout class="align-center mt-0 grid-po-info" flat grid-list-md>
            <v-flex wrap xs-12>
                <v-card>
                    <v-card-title class="title-box pt-3">
                        <v-toolbar-title>Purchase Order Information</v-toolbar-title>
                        <div class="actions-ref">
                            <v-btn @click="eventAddReferenceNumber($event)" color="primary">
                                Link reference number
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex md6 xs12>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Purchase Order No:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.po_number }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Customer name:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.customer_name }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Gender:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ getGenderText(purchaseOrderInfo.gender) }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Birthday:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.birthDay ? purchaseOrderInfo.birthDay.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, "$3-$2-$1") : "" | morph-date('YYYY/MM/DD') }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Customer Phone Number:</v-flex>
                                    <v-flex md6 xs12 class="body-2" style="text-decoration: none; color: red">
                                        {{ purchaseOrderInfo.phone_number }}
                                        <!--<a
                          v-bind:href="'tel:' + purchaseOrderInfo.phone_number"
                          style="text-decoration: none; color: red"
                  >{{purchaseOrderInfo.phone_number}}</a>-->
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Customer Email Address:</v-flex>
                                    <v-flex md6 xs12 class="body-2">
                                        <a v-bind:href="'mailto:' + purchaseOrderInfo.email" style="text-decoration: none;">{{ purchaseOrderInfo.email }}</a>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Job Site Address:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.execution_address }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Province:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.province }}</v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex md6 xs12>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Model:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.model && purchaseOrderInfo.model.name }}</v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Warranty Expired Date:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.warranty_expired_date | morph-date('YYYY/MM/DD') }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Maintain Expired Date:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.maintain_expired_date | morph-date('YYYY/MM/DD') }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Seller Email Address:</v-flex>
                                    <v-flex class="body-2" md6 xs12>
                                        <a style="text-decoration: none;" v-bind:href="'mailto:' + purchaseOrderInfo.seller_email_address">
                                            {{ purchaseOrderInfo.seller_email_address }}</a>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Next Maintain Date:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.next_maintain_date | morph-date('YYYY/MM/DD') }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Order Date:</v-flex>
                                    <v-flex class="body-2" md6 xs12>
                                        {{ purchaseOrderInfo.order_date | morph-date('YYYY/MM/DD') }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12>
                                <v-layout row wrap>
                                    <v-flex md3 xs12>Assign users:</v-flex>
                                    <v-flex class="body-2" md9 xs12>
                                        {{ purchaseOrderInfo.assign_users && purchaseOrderInfo.assign_users.length > 0 ? purchaseOrderInfo.assign_users.join(", ") : "" }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex md6 xs12>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Brand:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.brand }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Note:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.note }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>File:</v-flex>
                                    <!--                                <div >-->
                                    <v-flex class="body-2" md6 xs12>
                                        <div v-for="(file, key) in purchaseOrderInfo.files" :key="key" class="file-download">
                                            <p>{{ file.name || file.url }}</p>
                                            <a :href="file.url" download target="_blank">
                                                <v-btn flat icon color="rgba(0,0,0,0.54)">
                                                    <i class="material-icons">file_download</i>
                                                </v-btn>
                                            </a>
                                        </div>
                                    </v-flex>
                                    <!--                                </div>-->
                                    <!--                                <v-flex-->
                                    <!--                                    class="body-2"-->
                                    <!--                                    md6-->
                                    <!--                                    xs12-->
                                    <!--                                >http://lorem-file-test-long.com-->
                                    <!--                                  <a href="/images/myw3schoolsimage.jpg" download="#" style="outline-style: none; text-decoration: none;">-->
                                    <!--                                    <v-btn flat icon color="rgba(0,0,0,0.54)">-->
                                    <!--                                      <i class="material-icons">file_download</i>-->
                                    <!--                                    </v-btn>-->
                                    <!--                                  </a>-->
                                    <!--                                </v-flex>-->
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Required open height:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.required_open_height }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Required open Width:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.required_open_width }}
                                    </v-flex>
                                </v-layout>

                            </v-flex>
                            <v-flex md6 xs12>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance">
                                    <v-flex class="body-2" md12 xs12>Free maintenance:</v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_free_maintenance && purchaseOrderInfo.form_free_maintenance.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && !purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of remaining periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_free_maintenance && purchaseOrderInfo.form_free_maintenance.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.free_maintenance && !purchaseOrderInfo.is_new_data">
                                    <v-flex md6 xs12>Number of remaining periodic maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex class="body-2" md12 xs12>Chargeable maintenance:</v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex md6 xs12>Number of charged maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="purchaseOrderInfo.chargeable_maintenance">
                                    <v-flex md6 xs12>Number of remaining charged maintenance:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.remaining_periodic_maintenance }}
                                    </v-flex>
                                </v-layout>
                                <v-flex md12 xs12 v-for="(row, index) in purchaseOrderInfo.form_chargeable_maintenance && purchaseOrderInfo.form_chargeable_maintenance.form_contact" :key="index">
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex class="body-2" md12 xs12>Maintenance contract information:</v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Maintenance contract number:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.maintenance_contract_number }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Maintenance package:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.maintenance_package }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Contract signing date:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.contract_signing_date | morph-date('YYYY/MM/DD') }}
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-if="row.check_point">
                                        <v-flex md6 xs12>Expiration time:</v-flex>
                                        <v-flex class="body-2" md6 xs12>{{ row.effective_time | morph-date('YYYY/MM/DD') }}
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>In stock:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ inStock }}
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex md6 xs12>Company name:</v-flex>
                                    <v-flex class="body-2" md6 xs12>{{ purchaseOrderInfo.company_name }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>

    <div class="mb-4">
        <v-layout class="align-center" flat grid-list-md>
            <v-flex wrap xs-12>
                <v-card>
                    <v-card-title>
                        <v-toolbar-title>Job Information</v-toolbar-title>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="moduleData" :loading="loading" :pagination.sync="pagination" :total-items="totalItems" :rows-per-page-items="[5, 10, 20, 50]" class="elevation-1">
                            <template v-slot:headers="props">
                                <th v-for="header in props.headers" :key="header.text" :class="['column', !(typeof header.sortable === 'boolean' && !header.sortable) ? 'sortable' : '', header.align ? header.align : 'text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header)">
                                    {{ header.text }}
                                    <v-icon small v-if="!(typeof header.sortable === 'boolean' && !header.sortable)">arrow_upward
                                    </v-icon>
                                </th>
                            </template>
                            <template v-slot:items="props">
                                <tr :active="props.selected" @click="viewDetailJob($event, props.item)">
                                    <td class="text-xs-left">{{ getTypeJob(props.item.type) }}</td>
                                    <td class="text-xs-center">{{ props.item.execution_date | morph-date('YYYY/MM/DD') }}</td>
                                    <td class="text-xs-left">
                                        {{ props.item.performed_by ? props.item.performed_by.first_name + " " + props.item.performed_by.last_name : "" }}
                                    </td>
                                    <td class="text-xs-left">{{ props.item.status && props.item.status.name ? props.item.status.name : "" }}
                                    </td>
                                    <td class="text-xs-left">{{ getCompletionStatusText(props.item.isCompleted) }}</td>
                                    <td class="text-xs-left">
                                        <span class="truncate-content">{{ props.item.comment }}</span>
                                    </td>
                                    <td>
                                        <div class="d-flex">
                                            <v-icon small color="warning" v-for="n in props.item.zalo_rate" :key="n"> 
                                                star 
                                            </v-icon>
                                        </div>
                                    </td>
                                    <td class="text-xs-right">
                                        <v-btn @click="viewDetailJob($event, props.item)" flat icon color="rgba(0,0,0,0.54)">
                                            <i class="material-icons">visibility</i>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>

        </v-layout>
    </div>
</div>
</template>

<script>
import JobService from "../services/job.service";
import PurchaseOrderService from "../services/purchase.order.service";
import ReferenceService from "../services/referenceNumber.service";
import {
    debounce,
    isEmpty
} from "lodash";
import {
    setTimeout
} from "timers";
import genderList from "../config/genders";

export default {
    inject: ["$validator"],
    metaInfo() {
        return {
            title: "View Purchase Order Information"
        };
    },
    data: () => ({
        breadcrumbs: [{
                text: 'Purchase Order',
                disabled: false,
                to: '/purchase-order'
            },
            {
                text: 'Job',
                disabled: true,
                to: ''
            }
        ],
        pagination: {
            rowsPerPage: 10,
            sortBy: "updatedAt",
            descending: true,
            page: 1
        },
        paginationRef: {
            rowsPerPage: 10000,
            sortBy: "updatedAt",
            descending: true,
            page: 1
        },
        totalItems: 0,
        purchaseOrderInfo: {},
        dialog: false,
        warrantyDate: false,
        mainDate: false,
        nextDate: false,
        searchUser: null,
        search: null,
        editedIndex: -1,
        jobService: new JobService(),
        purchaseOrderService: new PurchaseOrderService(),
        referenceService: new ReferenceService(),
        editedItem: {
            first_name: "",
            last_name: "",
            email: "",
            password: "",
            user_type: "",
            active: true
        },
        reference_number: '',
        validForm: true,
        dialogConfirm: false,
        userList: [],
        refNumberList: [],
        loadingSelectUser: false,
        loadingSelectRef: false,
        sortBy: "",
        actionSearch: false,
        loading: false,
        id: "",
        inStock: 'No',
        rules: {
            required: value => !!value || "Required.",
            counter: value => value.length <= 20 || "Max 20 characters",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            }
        },
        userTypes: [{
                text: "User",
                value: 1
            },
            {
                text: "Technial Lead",
                value: 2
            }
        ],
        selected: [],
        headers: [{
                text: "Type",
                value: "type"
            },
            {
                text: "Execution Date",
                align: "text-xs-center",
                value: "createdAt"
            },
            {
                text: "Executor",
                value: "performed_by.first_name"
            },
            {
                text: "Status",
                value: "status.name",
            },
            {
                text: "Work status",
                value: "isCompleted",
            },
            {
                text: "Comment",
                value: "comment",
            },
            {
                text: "Rate",
                value: "zalo_rate",
            },
            {
                text: "Action",
                sortable: false,
                align: "text-xs-right"
            }
        ],
        moduleData: [],
        viewJob: false,
        infoJobDetail: {
            repair: []
        },
        isClick1: false,
        dialogImg: false,
        dialogReferenceNumber: false,
        listImages: []
    }),
    created() {
        this.getInfoPurchaseOrder();
        this.searchDataRefNumber();
    },
    watch: {
        pagination: {
            handler() {
                this.getData();
            },
            deep: true
        },
        searchUser(query) {
            this.querySearch({
                search: query
            });
        }
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ?
                "Add Purchase Order" :
                "Edit Purchase Order";
        },
        title1() {
            return 'Link Reference Number'
        },
        title2() {
            return "Are you sure to cancel the new reference number creation?"
        },
    },
    methods: {
        changeSort(data) {
            if (typeof data.sortable === 'boolean' && !data.sortable) return;
            const column = data.value;
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false
            }
            this.pagination.page = 1;
        },
        searchPo: debounce(function searchPo() {
            this.getData();
        }, 800),
        querySearch: debounce(function querySearch(query) {
            this.loadingSelectUser = true;
            this.loadingSelectRef = true;
            this.userService.getList(query).then(res => {
                this.userList = res.docs.map(e => {
                    return {
                        text: [e.first_name, e.last_name].join(" ") +
                            "<" +
                            e.email +
                            ">",
                        value: e.id
                    };
                });
                this.loadingSelectUser = false;
            });
        }, 500),
        searchDataRefNumber() {
            let params = {
                page: this.paginationRef.page,
                limit: this.paginationRef.rowsPerPage,
            };
            if (!isEmpty(this.search)) params.search = this.search;
            if (this.paginationRef.sortBy) {
                params.sort =
                    (this.paginationRef.descending ? "-" : "") + this.paginationRef.sortBy;
            }
            this.referenceService.getList(params).then(res => {
                this.refNumberList = res.docs.map(e => {
                    return {
                        text: e.reference_number,
                        value: e.reference_number
                    };
                });
                this.loadingSelectRef = false;
            });
        },
        close() {
            this.dialog = false;
            this.dialogReferenceNumber = false;
            this.dialogConfirm = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.$refs.formReferenceNumber.reset();
                this.editedIndex = -1;
            }, 300);
        },
        getTypeJob(type) {
            if (type === 1) return "Site check";
            else if (type === 2) return "Maintain";
            else if (type === 3) return "Repair";
            else if (type === 5) return "Acceptance";
            else if (type === 6) return "Preliminary"
            else if (type === 8) return "Survey"
            else return " Installation";
        },
        getGenderText(gender) {
            const mapping = genderList.find(m => m.value === gender);
            if (typeof mapping === "undefined") {
                return "Unknown";
            }
            return mapping.text;
        },
        getCompletionStatusText(isCompleted) {
            switch (isCompleted) {
                case void "":
                case true:
                    return "Đã hoàn thành";
                case false:
                    return "Chưa hoàn thành";
                default:
                    return "Không xác định";
            }
        },
        getInfoPurchaseOrder() {
            this.purchaseOrderService
                .getDetail(this.$route.params.id)
                .then(res => {
                    if (res.data) {
                        this.purchaseOrderInfo = res.data;
                        this.inStock = res.data.inStock ? 'Yes' : 'No';
                        if (
                            this.purchaseOrderInfo &&
                            this.purchaseOrderInfo.assign_users.length > 0
                        )
                            this.purchaseOrderInfo.assign_users = this.purchaseOrderInfo.assign_users.map(
                                e => {
                                    return (
                                        [e.first_name, e.last_name].join(" ") +
                                        "<" +
                                        e.email +
                                        ">"
                                    );
                                }
                            );
                    } else {
                        this.$router.push('/404');
                    }
                });
        },
        getData() {
            this.loading = true;
            let params = {
                page: this.pagination.page,
                purchase_order: this.$route.params.id,
                limit: this.pagination.rowsPerPage
            };
            if (!isEmpty(this.search)) params.search = this.search;
            if (this.pagination.sortBy) {
                params.sort =
                    (this.pagination.descending ? "-" : "") +
                    this.pagination.sortBy;
            }
            this.jobService.getList(params).then(res => {
                if (res) {
                    this.moduleData = res.docs;
                    this.loading = false;
                    this.totalItems = res.total;
                }
            });
        },
        editItem(item) {
            this.editedIndex = this.moduleData.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.id = this.moduleData[this.editedIndex].id;
            //remove search
            this.userList = this.editedItem.assign_users.map(e => {
                return {
                    text: [e.first_name, e.last_name].join(" ") +
                        "<" +
                        e.email +
                        ">",
                    value: e.id
                };
            });
            this.editedItem.assign_users = this.editedItem.assign_users.map(
                e => e.id
            );
            this.editedItem.warranty_expired_date = this.$morphDate(
                this.editedItem.warranty_expired_date,
                "YYYY-MM-DD"
            );
            this.editedItem.maintain_expired_date = this.$morphDate(
                this.editedItem.maintain_expired_date,
                "YYYY-MM-DD"
            );
            this.editedItem.next_maintain_date = this.$morphDate(
                this.editedItem.next_maintain_date,
                "YYYY-MM-DD"
            );
            this.dialog = true;
        },
        save() {
            this.$validator.validate('formReferenceNumber.*').then(result => {
                const data = {
                    ref_number: this.reference_number
                }
                if (result) {
                    this.purchaseOrderService.addReferenceNumber(this.$route.params.id, data).then(res => {
                                if (res.data && res.data.statusCode === 200) {
                                    this.close();
                                    this.getData();
                                } else {
                                    this.message = res.data.message;
                                }
                            });
                }
            })
        },
        viewDetailJob(e, item) {
            e.stopPropagation();
            if (this.isClick1) return;
            this.isClick1 = true;
            this.viewJob = true;

            this.$router.push({
                name: 'JobDetail',
                params: {
                    idPO: this.$route.params.id,
                    idJOB: item.id
                }
            });

            /*this.jobService.getDetail(item.id).then(res => {console.log(res);
                if (res.data !== undefined) {
                    this.infoJobDetail = res.data;
                    if (res.data.images !== undefined) {
                        /!*this.listImages = res.data.images.map(function (i, v) {
                            return {
                                thumb: v,
                                src: v
                            };
                        });*!/
                    }
                }
            });*/
        },
        eventAddReferenceNumber() {
            this.dialogReferenceNumber = true;
            this.validForm = false;
            setTimeout(function () {
                document.getElementsByClassName("dialog-referenceNumber")[0].scrollTop = 0;
            }, 300);
        },
        removeChip(data) {
            this.reference_number.splice(this.reference_number.indexOf(data), 1);
            this.reference_number = [...this.reference_number];
        },
    }
};
</script>

<style>
.content-detail-job .v-card {
    width: 100%;
}

.v-overlay:before {
    opacity: 0.8;
}

.file-download {
    justify-content: space-between;
    overflow-wrap: break-word;
    display: flex;
    height: 50px;
    overflow: hidden;
    margin-bottom: 10px;
}

.file-download p {
    display: inline-block;
    margin: 0;
    padding: 0;
    margin-top: 10px;
    height: 50px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

.file-download a {
    margin-top: 0;
    outline-style: none;
    text-decoration: none;
}

.v-card__title {
    font-size: 18px;
    font-weight: bold;
    background-color: #f5f5f5;
}

.theme--light.v-breadcrumbs a {
    text-decoration: none;
    font-size: 16px;
}

.theme--light.v-breadcrumbs .disabled {
    color: rgba(0, 0, 0, 0.87);
    cursor: auto;
}

.elevation-1 tr td:nth-child(1) {
    min-width: 120px;
}

.elevation-1 tr td:nth-child(3) {
    min-width: 200px;
}

.elevation-1 tr td:nth-child(4) {
    max-width: 500px;
    word-break: break-word;
}

.body-2 {
    word-break: break-word;
}

table.v-table tbody td {
    word-break: break-word;
}

.truncate-content {
    max-width: 520px;
    overflow: hidden;
    max-height: 8rem;
    -webkit-box-orient: vertical;
    display: block;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
}

.title-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
</style>
